'use client'

import React from 'react'

import cn from '../../libs/class-names'
import {pollImage} from '../../services/image'

export interface Props {
  classNames?: string[]
  // Required for a11y purposes
  alt: string
  source?: string
  fallbackSource?: string
  ratio?: 'default' | '1-1'
  fit?: 'cover' | 'contain'
}

const ImageContainer = ({
  source,
  fallbackSource,
  ratio = 'default',
  fit = 'cover',
  classNames,
  alt,
}: Props) => {
  const [imageLoaded, setImageLoaded] = React.useState(false)

  React.useEffect(() => {
    let pollHandle: ReturnType<typeof pollImage>

    if (source) {
      setImageLoaded(false)

      pollHandle = pollImage(source, () => {
        setImageLoaded(true)
      })
    }

    return () => {
      if (pollHandle) {
        pollHandle.cancel()
      }
    }
  }, [source])

  return (
    <div
      className={cn(
        'ImageContainer',
        {noSource: !source, [`ratio-${ratio}`]: !!ratio, [`fit-${fit}`]: !!fit},
        classNames
      )}
    >
      {imageLoaded && <img className="ImageContainer__image" src={source} alt={alt} />}
      {!imageLoaded && fallbackSource && (
        <img className="ImageContainer__image" src={fallbackSource} alt={alt} />
      )}
    </div>
  )
}

export default ImageContainer
